import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createNumericTransformer, createTimestampTransformer } from '../common/sql';
import {
  DBScalePointSchema,
  DBScaleSchema,
  DBVocabularyTermSchema,
  ScalePointSchema,
  ScaleSchema,
  VocabularyTermSchema,
} from './schemas';

export const VocabularyTermCodecConfig: TransformerConfig<
  typeof VocabularyTermSchema,
  typeof DBVocabularyTermSchema
> = {
  name: 'VocabularyTerm',
  clientSchema: VocabularyTermSchema,
  dbSchema: DBVocabularyTermSchema,
  transformers: [
    createTimestampTransformer<typeof VocabularyTermSchema, typeof DBVocabularyTermSchema>(
      'createdAt'
    ),
    createTimestampTransformer<typeof VocabularyTermSchema, typeof DBVocabularyTermSchema>(
      'updatedAt',
      { nullable: true }
    ),
  ],
};

export const ScaleCodecConfig: TransformerConfig<typeof ScaleSchema, typeof DBScaleSchema> = {
  name: 'Scale',
  clientSchema: ScaleSchema,
  dbSchema: DBScaleSchema,
  transformers: [
    ...(['minValue', 'maxValue'] as const).map(field =>
      createNumericTransformer<typeof ScaleSchema, typeof DBScaleSchema>(field)
    ),
    createTimestampTransformer<typeof ScaleSchema, typeof DBScaleSchema>('createdAt'),
    createTimestampTransformer<typeof ScaleSchema, typeof DBScaleSchema>('updatedAt', {
      nullable: true,
    }),
  ],
};

export const ScalePointCodecConfig: TransformerConfig<
  typeof ScalePointSchema,
  typeof DBScalePointSchema
> = {
  name: 'ScalePoint',
  clientSchema: ScalePointSchema,
  dbSchema: DBScalePointSchema,
  transformers: [
    createNumericTransformer<typeof ScalePointSchema, typeof DBScalePointSchema>('value'),
    createTimestampTransformer<typeof ScalePointSchema, typeof DBScalePointSchema>('createdAt'),
    createTimestampTransformer<typeof ScalePointSchema, typeof DBScalePointSchema>('updatedAt', {
      nullable: true,
    }),
  ],
};

export const encodeVocabularyTermToDb = createEncodeToDbFn(VocabularyTermCodecConfig);
export const decodeVocabularyTermFromDb = createDecodeFromDbFn(VocabularyTermCodecConfig);
export const encodeScaleToDb = createEncodeToDbFn(ScaleCodecConfig);
export const decodeScaleFromDb = createDecodeFromDbFn(ScaleCodecConfig);
export const encodeScalePointToDb = createEncodeToDbFn(ScalePointCodecConfig);
export const decodeScalePointFromDb = createDecodeFromDbFn(ScalePointCodecConfig);
